



























































import Vue, { PropType } from "vue";

// Model
import { FetchInstallationsPreventiveMaintenanceStatusReqData } from "@/model/communication/componentsMaintenance/FetchInstallationsPreventiveMaintenanceStatusCommand";
import { MaintenanceStatusEnum, MaintenanceStatusEnumToLabel, GetMachineMaintenanceStatusIconColor } from "@/model/data/status/MaintenanceStatusEnum";

export default Vue.extend({
    props: {
        filteredTotalsByStatus: {
            required: true,
        },
        totalsByStatus: {
            required: true,
            type: Map as PropType<Map<MaintenanceStatusEnum, number>>,
        },
        loading: {
            required: true,
            type: Boolean,
        },
        reqData: {
            type: Object as () => FetchInstallationsPreventiveMaintenanceStatusReqData,
        },
    },
    data() {
        return {
            ordering: { 0: 1, 1: 2, 2: 3 },
            firstTime: true,
        };
    },
    computed: {
        colsAttribute(): number {
            if (this.totalsByStatus.length % 3 == 0) return 4;
            return 6;
        },
    },
    watch: {
        loading(newValue) {
            if (!newValue) this.firstTime = false;
        },
    },
    methods: {
        GetMachineMaintenanceStatusIconColor,
        MaintenanceStatusEnumToLabel,

        toggleFilter(maintenanceStatus: MaintenanceStatusEnum) {
            let newReqData = { ...this.reqData };
            newReqData.offset = 0;

            if (this.reqData.maintenanceStatusList != null) {
                if (this.reqData.maintenanceStatusList.includes(maintenanceStatus)) {
                    newReqData.maintenanceStatusList = this.reqData.maintenanceStatusList.filter((v) => v != maintenanceStatus);
                    if (newReqData.maintenanceStatusList.length == 0) newReqData.maintenanceStatusList = null;
                } else newReqData.maintenanceStatusList.push(maintenanceStatus);
            } else {
                newReqData.maintenanceStatusList = [];
                newReqData.maintenanceStatusList.push(maintenanceStatus);
            }
            this.$emit("send-request", newReqData);
        },
    },
});
